const ContactInfoDefaults = {
    GEN: {
        type: 'group',
        conj: 'OR',
        children: [
            {
                type: 'rule',
                field: 'email1',
                basket: null,
                operator: 'IS NOT NULL',
                value: null,
            },
            {
                type: 'rule',
                field: 'mobile',
                basket: null,
                operator: 'IS NOT NULL',
                value: null,
            },
            {
                type: 'rule',
                field: 'home',
                basket: null,
                operator: 'IS NOT NULL',
                value: null,
            },
            {
                type: 'rule',
                field: 'work',
                basket: null,
                operator: 'IS NOT NULL',
                value: null,
            },
        ],
    },
    P2P: {
        type: 'rule',
        field: 'mobile',
        basket: null,
        operator: 'IS NOT NULL',
        value: null,
    },
    EMAIL: {
        type: 'group',
        conj: 'OR',
        children: [
            {
                type: 'rule',
                field: 'email1',
                basket: null,
                operator: 'IS NOT NULL',
                value: null,
            },
        ],
    },
    DIGILAB: {
        type: 'rule',
        field: 'email1',
        basket: null,
        operator: 'IS NOT NULL',
        value: null,
    },
    DONORANALYSIS: {
        type: 'group',
        conj: 'OR',
        children: [
            {
                type: 'rule',
                field: 'email1',
                basket: null,
                operator: 'IS NOT NULL',
                value: null,
            },
            {
                type: 'rule',
                field: 'mobile',
                basket: null,
                operator: 'IS NOT NULL',
                value: null,
            },
            {
                type: 'rule',
                field: 'home',
                basket: null,
                operator: 'IS NOT NULL',
                value: null,
            },
            {
                type: 'rule',
                field: 'work',
                basket: null,
                operator: 'IS NOT NULL',
                value: null,
            },
        ],
    },
    STAMP: {
        type: 'group',
        conj: 'AND',
        children: [
            {
                type: 'rule',
                field: 'address',
                basket: null,
                operator: 'IS NOT NULL',
                value: null,
            },
            {
                type: 'rule',
                field: 'date1',
                basket: null,
                operator: 'SINCE',
                value: '2024-01-01T05:00:00.000Z',
            },
            {
                type: 'rule',
                field: 'contribution_avg',
                basket: null,
                operator: '>=',
                value: 50,
            },
            {
                type: 'group',
                conj: 'OR',
                children: [
                    {
                        type: 'rule',
                        field: 'mail_conversions',
                        basket: null,
                        operator: '>',
                        value: 0,
                    },
                    {
                        type: 'rule',
                        field: 'modeled_mail_conversions',
                        basket: null,
                        operator: '>',
                        value: 0,
                    },
                ],
            },
        ],
    },
    CAUCUS: {
        type: 'group',
        conj: 'OR',
        children: [
            {
                type: 'rule',
                field: 'email1',
                basket: null,
                operator: 'IS NOT NULL',
                value: null,
            },
            {
                type: 'rule',
                field: 'mobile',
                basket: null,
                operator: 'IS NOT NULL',
                value: null,
            },
            {
                type: 'rule',
                field: 'home',
                basket: null,
                operator: 'IS NOT NULL',
                value: null,
            },
            {
                type: 'rule',
                field: 'work',
                basket: null,
                operator: 'IS NOT NULL',
                value: null,
            },
        ],
    },
};

const DONOR_LOOKUP = [
    {
        type: 'rule',
        field: 'first_name',
        basket: null,
        operator: '=',
        value: null,
    },
    {
        type: 'rule',
        field: 'last_name',
        basket: null,
        operator: '=',
        value: null,
    },
    {
        type: 'rule',
        field: 'city',
        basket: null,
        operator: '=',
        value: null,
    },
    {
        type: 'rule',
        field: 'state',
        basket: null,
        operator: 'IN',
        value: null,
    },
];

export const FilterPresets = [
    {
        name: 'GEN',
        value: 1,
        maxListLimit: 250000,
        conj: 'AND',
        acquisitionQueryDefaults: [
            {
                type: 'rule',
                field: 'contrib_ideology',
                basket: null,
                operator: '>=',
                value: 60,
            },
            {
                type: 'rule',
                field: 'shares_email',
                basket: null,
                operator: '<=',
                value: 20,
            },
            {
                type: 'rule',
                field: 'shares_mobile',
                basket: null,
                operator: '<=',
                value: 20,
            },
            {
                type: 'rule',
                field: 'ask',
                basket: null,
                operator: '>=',
                value: 500,
            },
            ContactInfoDefaults['GEN'],
        ],
        matchlistQueryDefaults: [ContactInfoDefaults['GEN']],
        sortingDefault: 'STAN',
    },
    {
        name: 'P2P',
        value: 2,
        maxListLimit: 1000000,
        conj: 'AND',
        acquisitionQueryDefaults: [ContactInfoDefaults['P2P']],
        matchlistQueryDefaults: [ContactInfoDefaults['P2P']],
        sortingDefault: 'RAND',
    },
    {
        name: 'EMAIL',
        value: 3,
        maxListLimit: 250000,
        conj: 'AND',
        acquisitionQueryDefaults: [
            {
                type: 'rule',
                field: 'shares_email',
                basket: null,
                operator: '<=',
                value: 20,
            },
            {
                type: 'rule',
                field: 'ask',
                basket: null,
                operator: '<=',
                value: 250,
            },
            {
                type: 'rule',
                field: 'active_email_score',
                basket: null,
                operator: '>=',
                value: 3,
            },
            {
                type: 'rule',
                field: 'risk_ratio',
                basket: null,
                operator: '<=',
                value: 1,
            },
            ContactInfoDefaults['EMAIL'],
        ],
        matchlistQueryDefaults: [ContactInfoDefaults['EMAIL']],
        sortingDefault: 'RAND',
    },
    {
        name: 'DIGILAB',
        value: 4,
        maxListLimit: 250000,
        conj: 'AND',
        acquisitionQueryDefaults: [ContactInfoDefaults['DIGILAB']],
        matchlistQueryDefaults: [ContactInfoDefaults['DIGILAB']],
        sortingDefault: 'RAND',
    },
    {
        name: 'DONORANALYSIS',
        value: 5,
        maxListLimit: 250000,
        conj: 'AND',
        acquisitionQueryDefaults: [ContactInfoDefaults['DONORANALYSIS']],
        matchlistQueryDefaults: [ContactInfoDefaults['DONORANALYSIS']],
        sortingDefault: 'RAND',
    },
    {
        name: 'STAMP',
        value: 6,
        maxListLimit: 500000,
        conj: 'AND',
        acquisitionQueryDefaults: [ContactInfoDefaults['STAMP']],
        matchlistQueryDefaults: [ContactInfoDefaults['STAMP']],
        sortingDefault: 'RAND',
    },
    {
        name: 'DONOR LOOKUP',
        value: 7,
        maxListLimit: 250000,
        conj: 'AND',
        acquisitionQueryDefaults: DONOR_LOOKUP,
        matchlistQueryDefaults: DONOR_LOOKUP,
        sortingDefault: 'RAND',
    },
    {
        name: 'DISTRICT',
        value: 8,
        maxListLimit: 250000,
        conj: 'AND',
        acquisitionQueryDefaults: [],
        matchlistQueryDefaults: [],
        sortingDefault: 'RAND',
    },
    {
        name: 'CAUCUS',
        value: 9,
        maxListLimit: 250000,
        conj: 'AND',
        acquisitionQueryDefaults: [ContactInfoDefaults['CAUCUS']],
        matchlistQueryDefaults: [ContactInfoDefaults['CAUCUS']],
        sortingDefault: 'RAND',
    },
];

// searchType.name values that are rental lists — sending these to Apical should warn the analyst first.
export const RENTAL_SEARCH_TYPES = ['STAMP', 'CAUCUS', 'P2P'];
